import { Tag } from '@luminovo/design-system';
import { formatAttribute } from '../model/RegionNetwork/formatAttribute';
import { formatAttributeValue } from '../model/RegionNetwork/formatAttributeValue';
import { Attribute } from '../model/RegionNetwork/types';

export function AttributeTag({ attr }: { attr: Attribute }): JSX.Element {
    return <Tag color="violet" label={`${formatAttribute(attr.attr)}: ${formatAttributeValue(attr)}`} />;
}
